import { render, staticRenderFns } from "./TheBatchSearchTab.vue?vue&type=template&id=527b0508"
import script from "./TheBatchSearchTab.vue?vue&type=script&lang=ts"
export * from "./TheBatchSearchTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports